export enum OrganizationType {
  Agent = 'Agent',
  Corporation = 'Corporation',
  FamilyOffice = 'FamilyOffice',
  Group = 'Group',
}
